export default __webpack_public_path__ + "de69e20ca59e65d079d8ed46bfc6f276.png";